module.exports = __webpack_public_path__ + "static/about-us-9f4fd3cfea2fafc942dfdf719e6e5cf6.jpg";